import {
  GET_FAVOURITES,
  GET_FAVOURITES_ERROR,
  GET_FAVOURITES_SUCCESS,
  SET_FAVOURITES,
  SET_FAVOURITES_ERROR,
  SET_FAVOURITES_SUCCESS,
  SET_USER_DATA,
  USER_LOG_OUT
} from './constants';

const initialState: UserState = {
  favorites: [],
  userData: undefined,
  requesting: false,
  successful: false,
  messages: [],
  errors: []
};

export default (state: UserState = initialState, action: any): UserState => {
  const {
    type
  } = action;

  switch (type) {
    case GET_FAVOURITES: {
      return {
        ...state,
        requesting: true,
        successful: false,
        messages: [],
        errors: []
      }
    }

    case GET_FAVOURITES_ERROR: {
      return {
        ...state,
        requesting: false,
        successful: false,
      }
    }

    case GET_FAVOURITES_SUCCESS: {
      return {
        ...state,
        favorites: action.data.getFavourites || [],
        requesting: false,
        successful: true,
        messages: [],
        errors: []
      }
    }

    case SET_FAVOURITES: {
      return {
        ...state
      }
    }

    case SET_FAVOURITES_SUCCESS: {
      return {
        ...state,
        favorites: action.data.setFavourites
      }
    }

    case SET_FAVOURITES_ERROR: {
      return {
        ...state,
        favorites: action.favourites || []
      }
    }

    case SET_USER_DATA: {
      return {
        ...state,
        userData: action.params
      }
    }

    case USER_LOG_OUT: {
      return {
        ...state,
        userData: undefined
      }
    }

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/reducer.ts